
import { EventType, trackEvent } from "@/helpers/AmplitudeHelper";
import { defineComponent } from "vue";
import { mapActions, mapGetters } from "vuex";

export default defineComponent({
  name: "ThePagination",
  props: {
    maxPage: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isMobile: window.innerWidth <= 767,
    };
  },
  computed: {
    ...mapGetters(['page', 'query', 'filters', 'queryCompany', 'queryFavourites', 'queryTemplates']),
    currentPage() {
      return Number(this.$route.query.page) || 1;
    },
    pages() {
      let pages: (number | string)[] = [];

      const sidePagesCount = this.isMobile ? 1 : 2;
      if (this.currentPage <= (this.isMobile ? 3 : 4) || this.maxPage <= 5) {
        pages = Array.from(
          { length: Math.min(5, this.maxPage) },
          (_, i) => i + 1
        );
      } else if (this.currentPage > this.maxPage - (this.isMobile ? 3 : 4)) {
        pages = Array.from(
          { length: 5 },
          (_, i) => this.maxPage - 4 + i
        );
      } else {
        const start = this.currentPage - sidePagesCount;
        pages = Array.from(
          { length: this.isMobile ? 3 : 5 },
          (_, i) => start + i
        );
      }

      const firstPage = pages[0];
      const lastPage = pages[pages.length - 1];

      if (typeof firstPage === "number") {
        if (firstPage > 2) {
          pages.unshift("...");
        }
        if (firstPage !== 1) {
          pages.unshift(1);
        }
      }

      if (typeof lastPage === "number") {
        if (lastPage < this.maxPage - 1) {
          pages.push("...");
        }
        if (lastPage !== this.maxPage) {
          pages.push(this.maxPage);
        }
      }

      return pages;
    },
  },
  methods: {
    ...mapActions(['setPage', 'getNewTenders', 'searchTenders', 'getFavourites', 'getTemplates']),
    async prevPage() {
      if (this.currentPage > 1) {
        await this.goToPage(this.currentPage - 1);
      }
    },
    async nextPage() {
      if (this.currentPage < this.maxPage) {
        await this.goToPage(this.currentPage + 1);
      }
    },
    async goToPage(pageNumber: number) {
      this.$router.push({ query: { ...this.$route.query, page: pageNumber } });
  
      if (this.$route.name === 'tenderSerp') {
        trackEvent(EventType.search_page_pagination, { page_number: pageNumber })
      } else if (this.$route.name === 'favourites') {
        trackEvent(EventType.favourites_pagination, { page_number: pageNumber })
      } else if (this.$route.name === 'templates') {
        trackEvent(EventType.templates_pagination, { page_number: pageNumber })
      } else if (this.$route.name === 'company') {
        trackEvent(EventType.company_page_pagination, { page_number: pageNumber })
      } else if (this.$route.name === 'companies') {
        trackEvent(EventType.companies_page_pagination, { page_number: pageNumber })
      }
    },
    checkWindowSize() {
      this.isMobile = window.innerWidth <= 767;
    },
  },
  mounted() {
    window.addEventListener("resize", this.checkWindowSize);
  },
  unmounted() {
    window.removeEventListener("resize", this.checkWindowSize);
  }
})
